import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=625a929e&scoped=true&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=625a929e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a929e",
  null
  
)

export default component.exports